/**
 * Global busy-indicator: poll zapd's `/debug/busy-state` und zeige im
 * Sidebar einen kleinen Spinner sobald irgendwas im Hintergrund läuft
 * (active session, keyframe-scan, oder ein Cron-Worker — letzterer kommt
 * mit Phase F auf demselben endpoint mit dazu).
 *
 * Nutzung:
 *   import { mountBusyIndicator } from './core/busyIndicator.js';
 *   mountBusyIndicator(document.querySelector('#sidebar-busy-slot'));
 *
 * Aktualisiert alle BUSY_POLL_MS, setzt `[hidden]` wenn nichts läuft.
 */
const BUSY_API = '/api-zapd/debug/busy-state';
const BUSY_POLL_MS = 5000;

export function mountBusyIndicator(slot) {
  if (!slot) return () => {};
  const el = document.createElement('div');
  el.className = 'zap-busy-indicator';
  el.hidden = true;
  el.innerHTML =
    '<div class="zap-busy-spinner" aria-hidden="true"></div>' +
    '<span class="zap-busy-label">Server arbeitet</span>';
  slot.appendChild(el);
  const labelEl = el.querySelector('.zap-busy-label');

  let stopped = false;
  let timer = null;

  async function poll() {
    if (stopped) return;
    try {
      const r = await fetch(BUSY_API, { credentials: 'include', cache: 'no-store' });
      if (r.ok) {
        const d = await r.json();
        const active = !!d.any_active;
        if (active) {
          el.hidden = false;
          const parts = [];
          if (d.active_scans > 0)    parts.push(`${d.active_scans}× Scan`);
          if (d.active_sessions > 0) parts.push(`${d.active_sessions}× Stream`);
          labelEl.textContent = 'Server: ' + (parts.join(', ') || 'aktiv');
        } else {
          el.hidden = true;
        }
      }
    } catch { /* network glitch — keep last state */ }
    if (!stopped) timer = setTimeout(poll, BUSY_POLL_MS);
  }
  poll();

  return () => {
    stopped = true;
    if (timer) { clearTimeout(timer); timer = null; }
    el.remove();
  };
}
